<template>
  <!-- 校验模型 -->
  <div class="training-step-model-verify">
    <div class="verify">
      <div class="verify-inner">
        <div class="intxt">
          <label class="label">
            <i class="required">*</i>选择校验模型：
          </label>
          <el-select
            class="select-box"
            v-model="activeModel"
            placeholder="请选择校验模型"
            filterable
          >
            <el-option
              v-for="item in modelOptions"
              :key="item.modelId"
              :label="item.modelName"
              :value="item.modelId"
            ></el-option>
          </el-select>
        </div>
        <div class="intxt">
          <label class="label">
            <i class="required">*</i>选择模型版本：
          </label>
          <el-select
            class="select-box"
            v-model="activeTrainingModel"
            placeholder="请选择模型版本"
            filterable
          >
            <el-option
              v-for="item in versionOptions"
              :key="item.trainModelId"
              :label="item.version"
              :value="item.trainModelId"
            ></el-option>
          </el-select>
        </div>

        <div v-if="modelType == 2">
          <div class="nav-label-checkbox">
            <ul>
              <li>模型标签<span>：</span></li>
              <li v-for="item in navCheckList" :key="item" @click="onSelectNavState(item)">
                <span>{{item}}</span>
              </li>
            </ul>
          </div>
          <ul class="list-tags" v-if="verifyResultImg && verifyResultImg[preview.index]">
            <li class="label-li" v-for="(item, idx) in verifyResultImg[preview.index].labelList" :key="idx">
              <i :class="[item.labelState ? 'el-icon-check i-select' : '']" :style="{'background':item.labelState?item.labelColor:'#fff',   'border-color':item.labelColor}" @click.stop="onSelectLabel(item.labelName)"></i>
              <span>{{ item.labelName }}</span>
            </li>
          </ul>
          <div class="line"></div>
        </div>

        <div
          class="verify-upload"
          v-show="activeModel && activeTrainingModel && !verificationModelProcessShow"
        >
          <el-button
            type="primary"
            :class="['btn-upload', 'btn-primary', {'events-disable': targetFileShow}]"
            @click="uploadForVerify"
            >上传{{modelTypeCompany(modelType)}}</el-button
          >
          <div class="verify-total">
            <span> <i class="required">*</i>{{modelTypeCompany(modelType)}}数量： </span>
            <span>{{ uploadFilePreview.length }}</span>
          </div>
          <div class="upload-img" v-if="modelType == 1 || modelType == 2">
            <!-- 图片滑动 -->
            <columns-slider
              class="slider"
              :pictures="uploadFilePreview"
              :active-image="preview"
              @image-click="activePreview"
              :sliderFileWidth="true"
              @prev="sliderPrev"
              @next="sliderNext"
              ref="imgSliderPrev"
            />
            <div class="figure">
              <div class="figure-box">
                <button class="btn-del" @click="removePreview(preview)" v-if="uploadFilePreview.length && !targetFileShow" title="删除">
                  <span class="icon-del"></span>
                  <!-- <icon-base v-bind="Icons.trashCan">
                    <icon-trash-can />
                  </icon-base> -->
                </button>
                <img v-if="modelType == 1" :src="preview.imgUrl" alt />
                <!-- 图片标注插件 -->
                <label-region-testModel
                  v-if="modelType == 2 && verifyResultImg"
                  :image="preview"
                  :img-tag="verifyResultImg[preview.index]"
                  ref="imgLabelRegion"
                ></label-region-testModel>
              </div>
            </div>
          </div>
          <div class="upload-img" v-if="modelType == 3 || modelType == 4">
            <!-- 文本滑动 -->
            <txt-slider
              class="slider"
              :pictures="uploadFilePreview"
              :active-image="preview"
              @image-click="activePreview"
              :sliderFileWidth="true"
              @prev="sliderPrev"
              @next="sliderNext"
              ref="txtSliderPrev"
            />
            <div class="figure">
              <div class="figure-box">
                <button class="btn-del" @click="removePreview(preview)" v-if="uploadFilePreview.length && !targetFileShow" title="删除">
                  <span class="icon-del"></span>
                </button>
                <div class="figure-text" v-html="textPreview"></div>
              </div>
            </div>
          </div>
          <div class="upload-img" v-if="modelType == 5 || modelType == 6">
            <!-- 音频滑动 -->
            <audio-slider
              class="slider"
              :pictures="uploadFilePreview"
              :active-image="preview"
              @image-click="activePreview"
              :sliderFileWidth="true"
              @prev="sliderPrev"
              @next="sliderNext"
              ref="audioSliderPrev"
            />
            <div class="figure audio-area-height">
              <div class="figure-box">
                <button class="btn-del" @click="removePreview(preview)" v-if="uploadFilePreview.length && !targetFileShow" title="删除">
                  <span class="icon-del"></span>
                </button>
                <!-- 音频波纹播放区 -->
                <audio-play-area v-if="modelType == 5" :currentAudioUrl="currentAudioUrl"></audio-play-area>
                <!-- 音频标注区 -->
                <audio-annotation-testModelArea
                  v-if="modelType == 6"
                  :annotationsList="uploadFilePreview"
                  :regionAudio="preview"
                  ref="audioLabelRegion"
                ></audio-annotation-testModelArea>
              </div>
            </div>
          </div>
        </div>
        <div class="btns">
          <el-button
            type="primary"
            :class="['btn-primary',
            {'events-disable': targetFileShow}]"
            @click="verifyStart"
          >开始校验</el-button>
        </div>
      </div>

      <div class="verify-result">
        <div class="title">校验结果：</div>
        <!-- 校验结果：图像分类/文本分类/文本标注/音频分类 -->
        <div class="result-tb" v-if="modelType == 1 || modelType == 3 || modelType == 4 || modelType == 5">
          <div class="thead-div">
            <span>索引</span>
            <span>预测分类</span>
            <span>置信度</span>
          </div>
          <div class="tbody-div">
            <div class="not-result" v-if="!verifyResult || verifyResult.length <= 0">
              <icon-base v-bind="Icons.notResult">
                <icon-not-result />
              </icon-base>
              <span>{{resultTips ? '未识别到目标对象！':'暂无校验结果！'}}</span>
            </div>
            <div class="result-tr" v-for="(item, idx) in verifyResult" :key="idx">
              <span>{{ idx + 1 }}</span>
              <span :title="item[0] ? item[0].labelName : item.labelName">
                {{ item[0] ? item[0].labelName : item.labelName || "未检测到物体" }}
              </span>
              <span>
                {{ item[0] ? item[0].confidence : item.confidence | confidence }}
              </span>
            </div>
          </div>
        </div>
        <!-- 校验结果：物体检测 -->
        <div class="result-tb table" v-if="modelType == 2">
          <div class="tr-labelTag-checkbox">
            <div class="nav-tr" v-for="item in navCheckList" :key="item">
              <span ><i @click="onSelectNavTagState(item)">{{item}}</i></span>
            </div>
          </div>
          <div class="thead-div">
            <span>索引</span>
            <span>预测分类</span>
            <span>置信度</span>
          </div>
          <div class="tbody-div">
            <div class="not-result" v-if="!verifyResultImg[preview.index] || verifyResultImg[preview.index].length <= 0">
              <icon-base v-bind="Icons.notResult">
                <icon-not-result />
              </icon-base>
              <span>{{resultTips ? '未识别到目标对象！':'暂无校验结果！'}}</span>
            </div>
            <div v-for="(item, idx) in verifyResultImg[preview.index]" :key="idx">
              <div class="result-tr list-tr" v-if="item.labelTagState">
                <span class="td-text-left">
                  <i :class="[item.isShow ? 'el-icon-check i-select' : '']" :style="{'background':item.isShow?item.labelColor:'#fff',   'border-color':item.labelColor}" @click.stop="onSelectLabelTag(item.labelTagId)"></i>
                  {{ idx + 1 }}
                </span>
                <span :title="item[0] ? item[0].labelName : item.labelName">
                  {{ item[0] ? item[0].labelName : item.labelName || "未检测到物体" }}
                </span>
                <span>
                  {{ item[0] ? item[0].confidence : item.confidence | confidence }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- 校验结果：音频标注 -->
        <div class="result-tb" v-if="modelType == 6">
          <div class="thead-div">
            <span>索引</span>
            <span>预测分类</span>
            <span>置信度</span>
          </div>
          <div class="tbody-div">
            <div class="not-result" v-if="!verifyResultAudio[preview.index] || verifyResultAudio[preview.index].length <= 0">
              <icon-base v-bind="Icons.notResult">
                <icon-not-result />
              </icon-base>
              <span>{{resultTips ? '未识别到目标对象！':'暂无校验结果！'}}</span>
            </div>
            <div class="result-tr" v-for="(item, idx) in verifyResultAudio[preview.index]" :key="idx">
              <span>{{ idx + 1 }}</span>
              <span :title="item[0] ? item[0].labelName : item.labelName">
                {{ item[0] ? item[0].labelName : item.labelName || "未检测到物体" }}
              </span>
              <span>
                {{ item[0] ? item[0].confidence : item.confidence | confidence }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗集 -->
    <div class="popup-list">
      <!-- 校验结果 -->
      <gat-popup
        :class="[
          'verify-report',
          popupActive === 'verify_report' ? 'on' : 'off'
        ]"
        :title="'校验结果'"
        @cancel="cancelPopup"
        @confirm="cancelPopup"
      >
        <template v-slot:content>
          <div class="report-cnt">
            <div class="loading" v-show="popupData.verify.status === 'loading'">
              模型校验正在进行…
            </div>

            <div class="error" v-show="popupData.verify.status === 'error'">
              模型校验出错，请再次尝试
            </div>
          </div>
        </template>
      </gat-popup>
      <!-- 上传图片提示 -->
      <model-training-upload-tips
        :modelType="modelType"
        :popupActive="popupActive"
        :uploadTipsType="'2'"
        @confirmUploadTip="confirmUploadTip"
        @cancelPopup="cancelPopup"
        @uploadNoTipChange="uploadNoTipChange"
      ></model-training-upload-tips>
    </div>
  </div>
</template>

<script>
import COMMON from "@/axios/common/common.js";
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js' // 项目标注接口

import GatPopup from "@/components/common/GatPopup";
import ColumnsSlider from "./components/ImgSlider";
import TxtSlider from './components/TxtSlider'
import AudioSlider from './components/AudioSlider'
import IconNotResult from "@/components/icons/typography/NotResult";
import AudioAnnotationTestModelArea from '@/components/pretrain/AudioAnnotationTestModelArea'
import AudioPlayArea from '@/components/pretrain/AudioPlayArea'
import LabelRegionTestModel from '@/components/pretrain/LabelRegionTestModel'
import ModelTrainingUploadTips from '@/components/pretrain/ModelTrainingUploadTips.vue'

import { debounce } from 'lodash' // 引入lodash数组函数方法
import { GetText } from '@/assets/js/mixin/mixinGetTextStr.js' // 解析txt文件
import { GetVerifyImgs } from '@/assets/js/mixin/mixinGetVerifyImgs.js'

export default {
  name: "TrainingStepModelVerify",
  components: {
    GatPopup,
    ColumnsSlider,
    TxtSlider,
    AudioSlider,
    IconNotResult,
    AudioAnnotationTestModelArea,
    AudioPlayArea,
    LabelRegionTestModel,
    ModelTrainingUploadTips,
  },
  mixins: [GetText, GetVerifyImgs],
  props: {
    navType: {
      type: String,
      default: ''
    },
    modelType: {
      type: String,
      default: ''
    },
    modelOptions: {
      type: Array,
      default: []
    },
    versionOptions: {
      type: Array,
      default: []
    },
    teacherOrStudentState: {
      type: Boolean,
      default: false
    },
    releaseStatus: {
      type: Boolean,
      default: false
    },
    targetFileList: {
      type: Array,
      default: []
    },
    targetFileShow: {
      type: Boolean,
      default: false
    },
  },
  filters: {
    confidence(val) {
      if (!val) {
        return;
      }
      return val > 0 ? parseFloat((Number(val) * 100).toFixed(2)) + "%" : "--";
    }
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址
      fileBaseUrl: window.gtaAiConfig.fileBaseUrl, // 资源平台上传基地址
      navCheckList: ['全选', '全不选', '反选'],
      currentNavlabel: '全选',
      labelList: [],
      labelColorList: ['#ff3399', '#cc0000', '#ff9900', '#ffff33', '#009900', '#0099cc', '#9933ff', '#336666', '#33ffff', '#3300ff', '#cc99cc', '#999999', '#ffcc99', '#660000', '#249662'],
      activeModel: "", // 激活的模型
      activeTrainingModel: "", // 激活的模型版本
      uploadFile: [], // 文件上传列表
      uploadFilePreview: [], // 上传文件预览
      preview: { imgUrl: "", index: 0, imgPos: {}, labelList: [], textName: "", textId: "", audioName: "", audioId: "" },
      textPreview: "", // 解析文本
      popupActive: "", // 弹窗
      popupData: {
        verify: {
          status: "",
          result: []
        },
        uploadNoTip: false,
      },
      durationList: [], // 音频列表总时长列表
      currentAudioUrl: '', // 当前音频路径
      // 当前音频
      currentAudio: {
        index: 0,
        audioUrl: '',
      },
      resultTips: false,
      formdata: new FormData(),
      fullscreenLoading: null, // 加载效果
      Icons: {
        notResult: {
          icoName: "",
          viewBox: "0 0 28 33",
          width: "28",
          height: "33"
        }
      },
      verificationModelProcessShow: false,
    }
  },
  computed: {
    // 校验结果
    verifyResult:{
      get() {
        return this.popupData.verify.result;
      },
      set(v) {}
    },
    // 校验结果：物体检测
    verifyResultImg:{
      get(){
        let labelColorList = this.labelColorList; // 颜色列表
        let imgList = this.popupData.verify.result; // 图片校验返回结果列表
        if (imgList && imgList.length) {
          imgList.forEach((item, index) => {
            let labelList = []; // 标签列表
            item.forEach((itn, idx) => {
              let timesId = new Date().getTime().toString() + idx;
              let flng = false;
              flng = labelList.every(i => {
                return i.labelName !== itn.labelName;
              });
              if (flng) {
                let num = labelList.length;
                // 获取返回结果的所有标签名
                labelList.push({
                  labelName: itn.labelName, // 标签名
                  labelColor: labelColorList[num], // 标签颜色
                  labelState: true, // 标签状态
                });
              }
  
              labelList.forEach(i => {
                if (i.labelName === itn.labelName) {
                  itn.labelColor = i.labelColor; // 标注颜色
                }
              });
  
              itn.labelTagId = timesId; // 标注id
              itn.labelTagState = true; // 控制标注显示隐藏状态
              itn.isShow = true; // 控制标注显示隐藏状态
            });
            item.labelList = labelList; // 当前图片标签列表
          });
        } else {
          setTimeout(() => {
            this.$refs.imgLabelRegion.updateTagImg([]); // 调用方法更新图片标注
          }, 100);
        }
        return imgList;
      },
      set (v) {}
    },
    // 校验结果：音频标注
    verifyResultAudio:{
      get() {
        return this.popupData.verify.result;
      },
      set(v) {}
    },
  },
  watch: {
    modelOptions: {
      handler(val) {
        if (val && val.length) {
          this.activeModel = val[0].modelId
        } else {
          this.activeModel = ''
        }
      },
      deep: true,
      immediate: true,
    },
    versionOptions: {
      handler(val) {
        if (val && val.length) {
          this.activeTrainingModel = val[0].trainModelId
        } else {
          this.activeTrainingModel = ''
        }
      },
      deep: true,
      immediate: true,
    },
    activeModel(activeModel) {
      // 初始化模型版本
      // if (!this.$route.query.modelId || this.$route.query.modelId != activeModel) {
      //   this.activeTrainingModel = "";
      // }
   
      // this.getTrainingModelList();
   
      // 初始化图片
      this.revokeObjectURL();
      this.uploadFile = [];
      this.popupData.verify.result = [];
    },
    // 混入方式获取解析的文本
    getTextStr(val) {
      if (val) {
        this.textPreview = val;
      }
    },
    targetFileShow: {
      handler(val) {
        if (val) {
          sessionStorage.uploadFilePreview = JSON.stringify(this.uploadFilePreview);
          this.targetFileList.forEach(item => {
            this.uploadFilePreview.push({
              imgId: item.fileId,
              imgUrl: this.photoBaseUrl + item.fileUrl,
              fileName: item.fileName,
              textId: item.fileId,
              textName: item.fileName,
              audioId: item.fileId,
              audioName: item.fileName,
            })
          });
          let image = this.uploadFilePreview[0];
          this.activePreview(image);

          // 老师查看学生校验结果、学生查看老师校验结果
          sessionStorage.verifyResult = JSON.stringify(this.popupData.verify.result);
          this.getCheckDataByTrainModelId();
        } else {
          this.uploadFilePreview = sessionStorage.uploadFilePreview ? JSON.parse(sessionStorage.uploadFilePreview) : [];
          this.popupData.verify.result = sessionStorage.verifyResult ? JSON.parse(sessionStorage.verifyResult) : [];
        }
      },
      deep: true,
      immediate: true,
    },
  },

  created() {},

  methods: {
    // 上一页
    sliderPrev(direct) {
      if (this.uploadFilePreview.length > 6) {
        let flang = true;
        this.uploadFilePreview.forEach((item, index) => {
          if (index < 6 && item.imgId === this.preview.imgId) {
            flang = false;
          }
        });
        if (flang) {
          let image = this.uploadFilePreview[0];
          this.activePreview(image);
        }
      }
    },
    // 下一页
    sliderNext(direct) {
      if (this.uploadFilePreview.length > 6) {
        let flang = true;
        this.uploadFilePreview.forEach((item, index) => {
          if (index >= 6 && item.imgId === this.preview.imgId) {
            flang = false;
          }
        });
        if (flang) {
          let image = this.uploadFilePreview[6];
          this.activePreview(image);
        }
      }
    },
    // 老师查看学生校验结果、学生查看老师校验结果
    getCheckDataByTrainModelId() {
      let data = {
        trainModelId: this.activeTrainingModel
      }
      MARKCENTER.getCheckDataByTrainModelId(data).then(result => {
        if (result.returnCode && result.data) {
          this.popupData.verify.result = JSON.parse(result.data)
        } else {
          this.popupData.verify.result = []
        }
      }).catch(err => {
        this.popupData.verify.result = []
      })
    },
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },
    // 物体检测：标签全选、全不选、反选
    onSelectNavState(navName) {
      this.currentNavlabel = navName;
      if (navName === '全选') {
        this.onSelectLabel(navName);
      } else if (navName === '全不选') {
        this.onSelectLabel(navName);
      } else { // 反选
        this.onSelectLabel(navName);
      }
      this.$forceUpdate(); // 强制更新数据
    },
    /* 物体检测：图片标签下所有标注显示隐藏 
     * labelState:true标签打钩
     * labelTagState：true右侧标注结果打钩
     * isShow：true图片上的标注显示
    */
    onSelectLabel (labelName) {
      let index = this.preview.index;
      if (this.verifyResultImg && this.verifyResultImg[index]) {
        // 标签列表
        this.verifyResultImg[index].labelList.forEach(item => {
          if (item.labelName === labelName) { // 判断点击了标签
            item.labelState = !item.labelState;
          }
  
          if (labelName === '全选') { 
            item.labelState = true;
          } else if (labelName === '全不选') {
            item.labelState = false;
          } else if (labelName === '反选') {
            item.labelState = !item.labelState;
          }
        });

        this.verifyResultImg[index].forEach(item => {
          if (item.labelName === labelName) { // 判断点击了标签
            item.labelTagState = !item.labelTagState;
            item.isShow = item.labelTagState;
          }
          if (labelName === '全选') {
            item.labelTagState = true;
            item.isShow = true;
          } else if (labelName === '全不选') {
            item.labelTagState = false;
            item.isShow = false;
          } else if (labelName === '反选') {
            item.labelTagState = !item.labelTagState;
            item.isShow = item.labelTagState;
          }
        });
        this.$refs.imgLabelRegion.updateTagImg(this.verifyResultImg[index]); // 调用方法更新图片标注
        this.$forceUpdate(); // 强制更新数据
      }
    },
    // 物体检测：标注全选、全不选、反选
    onSelectNavTagState(navName) {
      let index = this.preview.index;
      let labelList = this.verifyResultImg[index].labelList;
      if (this.verifyResultImg && this.verifyResultImg[index]) {
        this.verifyResultImg[index].forEach(item => {
          labelList.forEach(itm => {
            if (itm.labelState && itm.labelName === item.labelName) {
              if (navName === '全选') {
                item.isShow = true;
              } else if (navName === '全不选') {
                item.isShow = false;
              } else if (navName === '反选') {
                item.isShow = !item.isShow;
              }
            }
          });
        });
        this.$refs.imgLabelRegion.updateTagImg(this.verifyResultImg[index]); // 调用方法更新图片标注
        this.$forceUpdate(); // 强制更新数据
      }
    },
    // 物体检测：图片标注显示隐藏
    onSelectLabelTag (labelTagId) {
      let index = this.preview.index;
      this.verifyResultImg[index].forEach(item => {
        if (item.labelTagId === labelTagId) {
          item.isShow = !item.isShow;
        }
      });
      this.$refs.imgLabelRegion.updateTagImg(this.verifyResultImg[index]); // 调用方法更新图片标注
      this.$forceUpdate(); // 强制更新数据
    },

    // 图片上传说明
    activeUploadTipPopup() {
      this.popupActive = 'uploadtip';
    },
    // 上传提示显示后再进行上传操作
    confirmUploadTip() {
      this.cancelPopup(); // 关闭弹窗
      // TODO:上传图片事件触发
      this.uploadPicturesToDataset();
    },
    // 上传图片
    uploadNoTipChange(val) {
      this.localStorageUploadTip('save', val);
    },
    // 文件上传说明是否显示存储
    localStorageUploadTip(type, value) {
      if (type === 'save') {
        this.popupData.uploadNoTip = value;
        window.localStorage.setItem(`__upload_model_verify${this.modelType}_tip__`, value);
      } else {
        let uploadNoTip = window.localStorage.getItem(`__upload_model_verify${this.modelType}_tip__`);
        this.popupData.uploadNoTip = uploadNoTip ? uploadNoTip : false;
      }
    },
  
    // 上传校验图片/文本/音频
    uploadForVerify() {
      if (this.uploadFilePreview.length >= 10) {
        return this.$message.error('总数不超过10个哦~');
      }
      // TODO: 数据集选定、分类标签选定
      if (!this.popupData.uploadNoTip) {
        this.activeUploadTipPopup();
      } else {
        // 直接上传
        this.uploadPicturesToDataset();
      }
    },
    // 上传图片/文本/音频
    uploadPicturesToDataset() {
      let uploadFileNode = document.createElement("input"), // 创建上传按钮
        self = this;
  
      uploadFileNode.setAttribute("type", "file"); // 设置上传按钮属性
      uploadFileNode.setAttribute("multiple", "ture"); // 多文件上传
      if (self.modelType == 1 || self.modelType == 2) {
        uploadFileNode.setAttribute("accept", "image/jpeg,image/jpg"); // 限制图片上传
        // uploadFileNode.setAttribute("accept", "image/*"); // 限制图片除外的文件上传
      }
      if (self.modelType == 3 || self.modelType == 4) {
        uploadFileNode.setAttribute("accept", ".txt"); // 限制txt除外的文件上传
      }
      if (self.modelType == 5 || self.modelType == 6) {
        uploadFileNode.setAttribute("accept", ".mp3, .wav"); // 限制mp3/wav除外的文件上传
      }
  
      uploadFileNode.click(); // 触发上传事件
  
      // 上传进程，上传成功应要移除监听程序
      uploadFileNode.onchange = function uploadChange(evt) {
        let formdata = new FormData(), 
          files = evt.target.files,
          previewList = self.uploadFilePreview,
          uploadFile = self.uploadFile,
          list,
          formatPass = true;
  
        list = Array.from(files);
  
        // 上传加载效果
        self.fullscreenLoading = self.$loading({
          lock: true,
          text: '上传中请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
  
        let noFile = 0;
  
        // 图片分类，物体检测
        if (self.modelType == 1 || self.modelType == 2) {
          if (list.length + previewList.length > 10) {
            self.fullscreenLoading.close(); // 关闭Loading
            return self.$message.error('上传失败，图片上传总数最多不超过10个哦~');
          }
    
          self.noFile = 0;
          list.forEach((item, index) => {
            // self.selectUploadPicSize(item, list, index);
            let typeFlag = self.$util.filesFormatCheck(item, "jpg|jpeg"); // 检验文件类型
            if (typeFlag) {
              self.noFile++
              self.$message.error(`${item.name}上传失败，只允许上传 jpg/jpeg 格式图片！`);
            } else {
              formdata.append('file', item);
            }
          });
  
          if (list.length === self.noFile) {
            return self.fullscreenLoading.close(); // 关闭Loading
          }
          self.UploadMultipleFileApi(formdata) // 上传图片接口调用
          uploadFileNode = null; // 获取上传信息后移除上传元素
        }
  
        // 文本分类，文本标注
        if (self.modelType == 3 || self.modelType == 4) {
          if (list.length + previewList.length > 10) {
            self.fullscreenLoading.close(); // 关闭Loading
            return self.$message.error('上传失败，文本上传总数最多不超过10个哦~');
          }
    
          list.forEach(async (file) => {
            let typeFlag = self.$util.filesFormatCheck(file, 'txt');
            if (typeFlag) {
              noFile++;
              self.$message.error(`${file.name}上传失败，请上传格式为txt的文件！`);
            } else if (file.size > 500 * 1024) {
              noFile++;
              self.$message.error(`上传失败，文件名称为${file.name}格式过大！`);
            } else {
              formdata.append('file', file);
              // self.popupData.verify.result = [];
            }
          })
          if (list.length === noFile) {
            return self.fullscreenLoading.close(); // 关闭Loading
          }
  
          setTimeout(() => {
            COMMON.UploadMultipleFile(formdata).then((result) => {
              if (result.returnCode === 200) {
                let data = result.data;
                data.forEach(item => {
                  self.uploadFilePreview.splice(previewList.length, 1, {
                    imgId: item.id,
                    imgUrl: self.photoBaseUrl + item.url,
                    textName: item.fileName,
                    textId: item.id,
                  });
                });
  
                let filePath = self.photoBaseUrl + result.data[0].url;
                //混入函数
                this.getTxtContent(filePath); // 解析文本
                self.fullscreenLoading.close(); // 关闭Loading
  
                self.uploadFile = result.data.map(item => {
                  return {url: self.photoBaseUrl + item.url};
                });
              } else {
                self.$message.error(result.returnMsg);
                self.fullscreenLoading.close(); // 关闭Loading
              }
            }).catch((error)=>{
              console.log('error', error);
              self.fullscreenLoading.close(); // 关闭Loading
            });
          }, 100)
        }
  
        // 音频分类，音频标注
        if (self.modelType == 5 || self.modelType == 6) {
          if (list.length + previewList.length > 10) {
            self.fullscreenLoading.close(); // 关闭Loading
            return self.$message.error('上传失败，音频上传总数最多不超过10个哦~');
          }
    
          list.forEach(async (file) => {
            let typeFlag = self.$util.filesFormatCheck(file, 'mp3|MP3|wav|WAV');
            if (typeFlag) {
              noFile++;
              self.$message.error(`${file.name}上传失败，请上传格式为 wav/mp3 的音频！`);
            } else if (file.size > 5242880) {
              noFile++;
              self.$message.error(`上传失败，音频名称为${file.name}格式过大！`);
            } else {
              formdata.append('file', file);
              // self.popupData.verify.result = [];
            }
          })
          if (list.length === noFile) {
            return self.fullscreenLoading.close(); // 关闭Loading
          }
  
          let durationList = [];
          list.forEach(async (file) => {
            // audio获取音频总时长
            let url = URL.createObjectURL(file);
            let audioElement = new Audio(url);
            audioElement.addEventListener("loadedmetadata", function (_event) {
              durationList.push(audioElement.duration)
              // self.durationList.splice(self.durationList.length, 1, audioElement.duration)
            });
          })
  
          setTimeout(() => {
            COMMON.UploadMultipleFile(formdata).then((result) => {
              if (result.returnCode === 200) {
                let data = result.data;
                data.forEach((item, index) => {
                  self.uploadFilePreview.splice(previewList.length, 1, {
                    imgId: item.id,
                    imgUrl: self.photoBaseUrl + item.url,
                    audioName: item.fileName,
                    audioId: item.id,
                    audioDurationTotal: durationList[index],
                    audioList: [],
                  });
                });
  
                self.fullscreenLoading.close(); // 关闭Loading
  
                self.uploadFile = result.data.map(item => {
                  return {url: self.photoBaseUrl + item.url};
                });
              } else {
                self.$message.error(result.returnMsg);
                self.fullscreenLoading.close(); // 关闭Loading
              }
            }).catch((error)=>{
              console.log('error', error);
              self.fullscreenLoading.close(); // 关闭Loading
            });
          }, 100)
        }
      };
    },
    // 上传检验图片尺寸
    // async selectUploadPicSize(ev, arrList, index) {
    //   var self = this,
    //     uploadFile = ev,
    //     uploadFileList = self.uploadFile,
    //     previewList = self.uploadFilePreview;
  
    //   if (uploadFile) {
    //     if (window.FileReader) {
    //       var fr = new FileReader();
    //       fr.onloadend = await async function(e) {
    //         let typeFlag = self.$util.filesFormatCheck(uploadFile, 'jpg|jpeg'); // 检验文件类型
    //         if (typeFlag) {
    //           self.noFile++
    //           self.$message.error(`${uploadFile.name}上传失败，只允许上传 jpg/jpeg 格式图片！`);
    //         } else {
    //           // 声明新Image
    //           var img = new Image();
    //           // 此处不做任何压缩直接读取文件流显示为图片（可扩展为压缩图片后显示）
    //           img.src = e.target.result;
    //           img.onload = await function() {
    //             // 图片格式大小尺寸区间
    //             if (uploadFile.size > 4194304) {
    //               self.noFile++
    //               self.$message.error(`上传失败，图片名称为${uploadFile.name}格式过大！`);
    //             } else if (this.width > 2048 || this.height > 2048 ) {
    //               self.noFile++;
    //               self.$message.error(`上传失败，图片名称为“${uploadFile.name}”分辨率大于2048px*2048px！`);
    //             } else if (this.width < 64 || this.height < 64) {
    //               self.noFile++;
    //               self.$message.error(`上传失败，图片名称为“${uploadFile.name}”分辨率小于64px*64px！`);
    //             } else {
    //               self.formdata.append('file', uploadFile); // 追加图片文件
    //             }
    //           }
    //         }
            
    //         if (arrList.length === (index + 1)) {
    //           setTimeout(() => {
    //             if (arrList.length === self.noFile) {
    //               return self.fullscreenLoading.close(); // 关闭Loading
    //             }
    //             self.UploadMultipleFileApi(); // 上传图片接口调用
    //           }, 1000);
    //         }
    //       }
    //       fr.readAsDataURL(uploadFile);
    //     }
    //   } else {
    //     self.fullscreenLoading.close(); // 关闭Loading
    //   }
    // },
    UploadMultipleFileApi(formdata) {
      let self = this,
        previewList = self.uploadFilePreview;
  
      // 获取文件上传地址
      COMMON.UploadMultipleFile(formdata).then(result => {
        if (result.returnCode === 200) {
          let dataList = JSON.parse(JSON.stringify(result.data));
          let imgList = [];
          dataList.forEach((item, index) => {
            // 图片格式大小尺寸区间
            if (item.size && item.size > 4194304) {
              setTimeout(() => {
                self.$message.error(`上传失败，图片名称为${item.fileName}格式过大！`);
              }, index*5);
            } else if (item.width&&item.width > 2048 || item.height&&item.height > 2048 ) {
              setTimeout(() => {
                self.$message.error(`上传失败，图片名称为“${item.fileName}”分辨率大于2048px*2048px！`);
              }, index*5);
            } else if (item.width&&item.width < 64 || item.height&&item.height < 64) {
              setTimeout(() => {
                self.$message.error( `上传失败，图片名称为“${item.fileName}”分辨率小于64px*64px！`);
              }, index*5);
            } else {
              imgList.push(item);
            }
          });

          if (imgList.length === 0) {
            self.fullscreenLoading.close(); // 关闭Loading
            self.formdata = new FormData();  // 释放
            return
          }

          // 校验图片jpg|jpeg
          self.verifyImgs(imgList).then(res => {
            if (res.correct && res.correct.length) {
              let data = {
                datasetImgList: []
              };
  
              res.correct.forEach(i => {
                imgList.forEach(j => {
                  if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
                    data.datasetImgList.push(j);
                  }
                });
              });
  
              data.datasetImgList.forEach(item => {
                self.uploadFilePreview.splice(previewList.length, 1, {
                  imgId: item.id,
                  imgUrl: self.photoBaseUrl + item.url
                });
              });
            }
          })
          self.fullscreenLoading.close(); // 关闭Loading
          self.formdata = new FormData(); // 释放
        } else {
          self.fullscreenLoading.close(); // 关闭Loading
          self.formdata = new FormData(); // 释放
        }
      }).catch(err => {
        console.log('error', err)
        self.fullscreenLoading.close(); // 关闭Loading
        self.formdata = new FormData(); // 释放
      });
    },

    // 开始校验
    verifyStart() {
      if (!this.uploadFilePreview || this.uploadFilePreview.length <= 0) {
        let msg = `请上传${this.modelTypeCompany(this.modelType)}!`;
        return this.$message.warning(msg);
      }
  
      this.toStartVerification();
    },
    // 校验模型：防抖
    toStartVerification:debounce(function(type) {
      if (this.modelType == 1 || this.modelType == 2) {
        this.popupData.verify.result = [];
        // let imgUrls = this.uploadFilePreview.map(item => item.imgUrl);
        let imgUrls = [];
        this.uploadFilePreview.forEach(item => {
          imgUrls.push(this.fileBaseUrl + '/aishixun' + item.imgUrl.split('/aishixun')[1]);
        });
        this.popupActive = "verify_report";
        this.popupData.verify.status = "loading";
        // 检验接口
        this.verifyModel(imgUrls);
      }
  
      if (this.modelType == 3 || this.modelType == 4 || this.modelType == 5) {
        // let imgUrls = this.uploadFilePreview.map(item => item.imgUrl);
        let imgUrls = [];
        this.uploadFilePreview.forEach(item => {
          imgUrls.push(this.fileBaseUrl + '/aishixun' + item.imgUrl.split('/aishixun')[1]);
        });
        this.popupActive = "verify_report";
        this.popupData.verify.status = "loading";
        // 检验接口
        this.verifyModel(imgUrls);
      }
  
      if (this.modelType == 6) {
        let audioList = this.$refs.audioLabelRegion.getAudioList(); // 获取音频数据列表
        this.popupActive = "verify_report";
        this.popupData.verify.status = "loading";
        let audioInfos = [];
        audioList.forEach(item => {
          item.audioList.forEach(i => {
            i.audioUrl = this.fileBaseUrl + '/aishixun' + i.audioUrl.split('/aishixun')[1];
          });
          audioInfos.push(item.audioList);
        });
        // 检验接口：音频标注
        this.verifyAudioTagModel(audioInfos);
      }
    }, 500),
    // 检验接口：图片分类、物体检测、文本分类、文本标注、音频分类
    verifyModel(imgUrls) {
      let algorithmId,
        data = {};
  
      // 算法 ID : algorithmId = this.activeTrainingModel;
      algorithmId = this.versionOptions.find(
        item => item.trainModelId === this.activeTrainingModel
      ).algorithmId;
  
      data = {
        algorithmId,
        urls: imgUrls,
        modelType: this.modelType,
      };
  
      MARKCENTER.verifyModel(data).then(res => {
        if (res.isSuccess) {
          // 显示返回的内容
          if (res.data) {
            if (Array.isArray(res.data) && res.data.length > 0) {
              this.popupData.verify.result = res.data;
            } else if (typeof res.data === "object" && res.data != null) {
              this.popupData.verify.result = [res.data];
            }
          }
          this.$message.success('校验成功！');
          this.resultTips = true;
          this.popupData.verify.status = "success";
          this.popupActive = "";
          this.verificationModelProcessShow = false;
          this.$emit('toModelRelease');
        } else {
          // this.$message.error(res.returnMsg);
          this.resultTips = false;
          this.popupData.verify.status = "error";
        }
      });
    },
    // 检验接口：音频标注
    verifyAudioTagModel(audioInfos) {
      let algorithmId,
        modelType = this.modelType,
        data = {};
  
      // 算法 ID : algorithmId = this.activeTrainingModel;
      algorithmId = this.versionOptions.find(
        item => item.trainModelId === this.activeTrainingModel
      ).algorithmId;
  
      data = {
        algorithmId,
        audioInfos: audioInfos,
        modelType: modelType
      };
  
      MARKCENTER.verifyAudioTagModel(data).then(res => {
        if (res.isSuccess) {
          // 显示返回的内容
          if (res.data) {
            if (Array.isArray(res.data) && res.data.length > 0) {
              this.popupData.verify.result = res.data;
            }
          }
          this.$message.success('校验成功！');
          this.resultTips = true;
          this.popupData.verify.status = "success";
          this.popupActive = "";
          this.verificationModelProcessShow = false;
        } else {
          // this.$message.error(res.returnMsg);
          this.resultTips = false;
          this.popupData.verify.status = "error";
        }
        this.$emit('toModelRelease')
      });
    },
    // 激活预览
    activePreview(image, index) {
      // console.log('激活预览', image, index)
      this.preview = {
        index: index || 0,
        imgId: image.imgId || '',
        imgUrl: image.imgUrl || '',
        imgPos: image.pos || {},
        labelList: image.labelList || [],
        textId: image.imgId || '',
        textName: image.textName || '',
        audioId: image.audioId || '',
        audioName: image.audioName || '',
        audioDurationTotal: image.audioDurationTotal || 0,
        audioList: image.audioList || [],
      };
      this.currentAudioUrl = image.imgUrl || '';
  
      if (this.modelType == 2 && this.verifyResultImg && this.verifyResultImg[index]) { // 切换图片
        // 默认全选全部标签标注展示
        this.verifyResultImg[index].labelList.forEach(item => {
          item.labelState = true;
        });
        this.verifyResultImg[index].forEach(item => {
          item.isShow = true;
          item.labelTagState = true;
        });
        // 调用方法更新图片标注
        this.$refs.imgLabelRegion.updateTagImg(this.verifyResultImg[index]);
      }
      if (image.imgUrl && this.modelType == 3 || this.modelType == 4) {
        this.getTxtContent(image.imgUrl); // 混入函数: 解析文本
      }

      this.$forceUpdate()
    },
    // 删除文本触发
    removePreview(preview) {
      var url = preview.imgUrl,
        index = preview.index,
        modelType = this.modelType;
  
      if (index < 0) {
        return;
      }
  
      this.currentAudioUrl = '';
      this.uploadFilePreview.splice(index, 1);
      this.uploadFile.splice(index, 1);
      window.URL.revokeObjectURL(url); // 移除图片资源内存
  
      let idxNum = 1;
      if (index > 0 && this.uploadFilePreview.length) {
        if (this.uploadFilePreview.length > index) {
          idxNum = index;
        } else {
          idxNum = index - 1;
        }
        this.preview = this.uploadFilePreview[idxNum];
        // console.log(this.preview)
      } else if (index == 0 && this.uploadFilePreview.length) {
        this.preview = this.uploadFilePreview[index];
      } else {
        this.preview = { imgUrl: "", index: -1, imgPos: {}, labelList: [], textName: "", textId: "", audioName: "", audioId: "" };
      }
      this.preview.index = index == 0 ? index : idxNum;
      // this.preview = { imgUrl: "", index: -1, imgPos: {}, labelList: [], textName: "", textId: "", audioName: "", audioId: "" };
      if (this.uploadFilePreview.length === 0) {
        this.textPreview = '';
      }
      if (modelType == 1 || modelType == 3 || modelType == 4 || modelType == 5) {
        this.verifyResult.splice(index, 1);
      }
      if (modelType == 2) {
        this.verifyResultImg.splice(index, 1);
      }
      if (modelType == 6) {
        this.verifyResultAudio.splice(index, 1);
      }
      // this.$forceUpdate() // 强制更新数据
      let uploadLength = this.uploadFilePreview.length;
      if (uploadLength % 6 === 0) { // 取模6（余数）等于0触发上一页
        if (modelType == 1 || modelType == 2) {
          this.$refs.imgSliderPrev.onSliderPrev(); // 图片调用子组件方法上一页
        } else if (modelType == 3 || modelType == 4) {
          this.$refs.txtSliderPrev.onSliderPrev(); // 文本调用子组件方法上一页
        } else if (modelType == 5 || modelType == 6) {
          this.$refs.audioSliderPrev.onSliderPrev(); // 音频调用子组件方法上一页
        }
      }
    },
    // 全部移除图片资料
    revokeObjectURL() {
      if (this.uploadFilePreview) {
        this.uploadFilePreview.forEach(item => {
          window.URL.revokeObjectURL(item.imgUrl);
        });
  
        this.uploadFilePreview = [];
      }
    },
    // 取消弹窗
    cancelPopup() {
      this.popupActive = '';
    },
  },
}
</script>

<style lang="scss" scoped>
@import './TrainingStepModelVerify.scss';
</style>